import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import CeasingOperations from '../components/ceasing-operations/ceasing-operations';

const CeasingOperationsPage = () => (
  <Layout>
    <SEO title="Maesh is Ceasing Operations for its payments services on January 28, 2021" />  
    <CeasingOperations/>
  </Layout>

)

export default CeasingOperationsPage